import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MapService, MarkerMode } from '../../../map.service';
import { _ } from '~shared/utils';

@Component({
  selector: 'qm-marker-mode-settings',
  templateUrl: './marker-mode-settings.component.html',
  styleUrls: ['./marker-mode-settings.component.scss']
})
export class MarkerModeSettingsComponent implements OnInit, OnDestroy {

  public modes = Object.values(MarkerMode);
  public selectedMode: MarkerMode;
  private ngUnsubscribe = new Subject<void>();

  public markerModeLabels = {
    [MarkerMode.HTML]: _('Large markers'),
    [MarkerMode.Canvas]: _('Small markers (beta)'),
  };

  constructor(private mapService: MapService, private cdr: ChangeDetectorRef) { }

  public ngOnInit(): void {
    this.mapService.markerMode$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(mode => {
        this.selectedMode = mode;
        this.cdr.markForCheck();
      });
  }

  public ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  public onSelectedModeChanged(mode: MarkerMode) {
    this.mapService.setMarkerMode(mode);
  }

}
